import { gql, } from 'apollo-boost'

export const GET_DISCOUNT_CARD_API = gql`
	query searchDiscountCard($pattern: String!) {
		cards: searchDiscountCard(pattern: $pattern)
	}
`
